import React, { useState } from "react";
import AddProjects from "./component/addProject";

// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";

function ProjectView() {
  // Initialize holidaysData with default value (could be an empty array)
  const [holidaysData, setHolidaysData] = useState([]);

  return (
    <>
      <AddProjects
        holidaysData={holidaysData}
        setHolidaysData={setHolidaysData}
      />
    </>
  );
}

export default ProjectView;
